"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSTANTS = void 0;
exports.CONSTANTS = {
    REGEX: /^([2-9]\d{2}){2}\d{4}$/,
    MASK: '(###) ###-####',
    PREFIX: '+1',
};
//# sourceMappingURL=phone.constants.js.map